"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _header = _interopRequireDefault(require("../header"));

var _axios = _interopRequireDefault(require("axios"));

var _DashboardTimezoneDisclaimer = require("./DashboardTimezoneDisclaimer");

var _KeyInsightCard = require("./KeyInsightCard");

var _AnalyticsDateFormatter = _interopRequireDefault(require("./AnalyticsDateFormatter"));

var _interfaces = require("./interfaces");

var _utils = require("./utils");

var _TopUsersTable = _interopRequireDefault(require("./TopUsersTable"));

var _DashboardSimpleFilter = _interopRequireDefault(require("./DashboardSimpleFilter"));

var _DashboardDateRangeFilter = _interopRequireDefault(require("./DashboardDateRangeFilter"));

var _QueryParameters = _interopRequireDefault(require("./QueryParameters"));

var _common = require("@insided/shared/utils/common");

var _logger = require("@insided/shared/services/logger");

var _NewRegistrationsGraph = _interopRequireDefault(require("./UserDashboard/NewRegistrationsGraph"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var UserDashboard = /*#__PURE__*/function (_Dashboard) {
  (0, _inherits2.default)(UserDashboard, _Dashboard);

  var _super = _createSuper(UserDashboard);

  function UserDashboard() {
    var _this;

    (0, _classCallCheck2.default)(this, UserDashboard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "wrapperRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isRankModuleEnabled", _common.common.isModuleActive('rank'));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", _this.getInitialState());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addHandler", function () {
      var _this$state = _this.state,
          isDateRangeOpen = _this$state.isDateRangeOpen,
          isUserRoleDropdownOpen = _this$state.isUserRoleDropdownOpen,
          isRankDropdownOpen = _this$state.isRankDropdownOpen;

      if (isDateRangeOpen || isUserRoleDropdownOpen || isRankDropdownOpen) {
        window.document.addEventListener('mousedown', _this.handleClickOutside);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeHandler", function () {
      window.document.removeEventListener('mousedown', _this.handleClickOutside);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickOutside", function (e) {
      if (!_this.wrapperRef) return;

      if (!_this.wrapperRef.contains(e.target)) {
        _this.onResetDateRange();

        _this.setState({
          isUserRoleDropdownOpen: false,
          isRankDropdownOpen: false
        }, _this.removeHandler);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchUserRoles", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var res;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _axios.default.get('/role/fetchRolesForFilter');

            case 2:
              res = _context.sent;
              return _context.abrupt("return", (0, _utils.normalizeRoles)(res.data));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchRanks", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var res;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _axios.default.get('/settings/rank/fetchRanks');

            case 2:
              res = _context2.sent;
              return _context2.abrupt("return", (0, _utils.normalizeUserRanks)(res.data));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refetchData", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var totalUsersPromise, usersWithOnePostPromise;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              totalUsersPromise = _this.fetchTotalUsers();

              _this.fetchNewRegistrations();

              usersWithOnePostPromise = _this.fetchUsersWithOnePost();
              _context3.next = 5;
              return usersWithOnePostPromise;

            case 5:
              _context3.next = 7;
              return totalUsersPromise;

            case 7:
              _this.calculatePercentageUsersWithOnePost();

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchDateRangeFilter", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var res;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _axios.default.get('/analyticsV2/fetchDateRangeFilter');

            case 2:
              res = _context4.sent;
              return _context4.abrupt("return", res.data.ranges);

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchData", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(url) {
        var _this$state2, startDate, endDate, mainRoles, customRoles, selectedRanks, filterOptions;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this$state2 = _this.state, startDate = _this$state2.startDate, endDate = _this$state2.endDate, mainRoles = _this$state2.mainRoles, customRoles = _this$state2.customRoles, selectedRanks = _this$state2.selectedRanks;
                filterOptions = {
                  start: _AnalyticsDateFormatter.default.formatDate(startDate),
                  end: _AnalyticsDateFormatter.default.formatDate(endDate, false),
                  mainRoles: mainRoles,
                  customRoles: customRoles,
                  ranks: selectedRanks
                };
                _context5.next = 4;
                return _axios.default.post(url, {
                  filters: filterOptions
                });

              case 4:
                return _context5.abrupt("return", _context5.sent);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleUserRoleDropdown", function (value) {
      if (_this.state.isRankDropdownOpen) {
        _this.onResetRanks();
      }

      if (_this.state.isDateRangeOpen) {
        _this.onResetDateRange();
      }

      _this.setState({
        isUserRoleDropdownOpen: value
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUserRolesChanged", function (data) {
      var userRoles = _this.state.userRoles;
      var mainRoles = (0, _utils.getSelectedRolesForRequest)(userRoles, data);
      var customRoles = (0, _utils.getSelectedRolesForRequest)(userRoles, data, false);

      _this.setState({
        isUserRoleDropdownOpen: false,
        selectedRoles: data,
        mainRoles: mainRoles,
        customRoles: customRoles
      });

      window.history.pushState(null, 'roles changed', new _QueryParameters.default().set('roles', data.join(',')).getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetUserRoles", function () {
      _this.setState({
        isUserRoleDropdownOpen: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearUserRoles", function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        selectedRoles: [],
        mainRoles: [],
        customRoles: [],
        isUserRoleDropdownOpen: false
      });

      window.history.pushState(null, 'roles cleared', new _QueryParameters.default().unset('roles').getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleRankDropdown", function (value) {
      if (_this.state.isUserRoleDropdownOpen) {
        _this.onResetUserRoles();
      }

      if (_this.state.isDateRangeOpen) {
        _this.onResetDateRange();
      }

      _this.setState({
        isRankDropdownOpen: value
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRanksChanged", function (data) {
      _this.setState({
        isRankDropdownOpen: false,
        selectedRanks: data
      });

      window.history.pushState(null, 'ranks changed', new _QueryParameters.default().set('ranks', data.join(',')).getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetRanks", function () {
      _this.setState({
        isRankDropdownOpen: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearRanks", function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        selectedRanks: [],
        isRankDropdownOpen: false
      });

      window.history.pushState(null, 'ranks cleared', new _QueryParameters.default().unset('ranks').getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleDateRange", function (value) {
      if (_this.state.isRankDropdownOpen) {
        _this.onResetRanks();
      }

      if (_this.state.isUserRoleDropdownOpen) {
        _this.onResetUserRoles();
      }

      _this.setState({
        isDateRangeOpen: value
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPresetDateRangeChanged", function (selectedDate) {
      _this.setState({
        selectedPresetDateRangeId: selectedDate.id,
        selectedDate: selectedDate
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCustomDateRangeChanged", function (dates) {
      var customSelectedDate = {
        id: 'custom_range',
        label: 'Custom Range',
        startDate: dates[0],
        endDate: dates[1]
      };

      _this.setState({
        selectedDate: customSelectedDate,
        selectedPresetDateRangeId: customSelectedDate.id
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDateRangeChanged", function () {
      var _this$state3 = _this.state,
          selectedDate = _this$state3.selectedDate,
          selectedPresetDateRangeId = _this$state3.selectedPresetDateRangeId,
          storedState = _this$state3.storedState;

      var updatedState = _objectSpread({}, storedState);

      updatedState.presetDateRangeId = selectedPresetDateRangeId;
      updatedState.selectedDateRange = selectedDate;

      _this.setState({
        isDateRangeOpen: false,
        startDate: new Date(selectedDate.startDate),
        endDate: new Date(selectedDate.endDate),
        storedState: updatedState
      });

      var queryString = new _QueryParameters.default();
      queryString.set('date_range', selectedPresetDateRangeId);

      if (selectedPresetDateRangeId !== 'custom_range') {
        queryString.unset('date_from').unset('date_till');
      } else {
        queryString.set('date_from', _AnalyticsDateFormatter.default.formatDateForUrl(selectedDate.startDate)).set('date_till', _AnalyticsDateFormatter.default.formatDateForUrl(selectedDate.endDate));
      }

      window.history.pushState(null, 'date range changed', queryString.getQueryString());
      (0, _utils.updateDateRangeInSessionStorage)(selectedDate);

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetDateRange", function () {
      var _this$state$storedSta = _this.state.storedState,
          presetDateRangeId = _this$state$storedSta.presetDateRangeId,
          selectedDateRange = _this$state$storedSta.selectedDateRange;

      _this.setState({
        isDateRangeOpen: false,
        selectedPresetDateRangeId: presetDateRangeId,
        selectedDate: selectedDateRange
      });
    });
    return _this;
  }

  (0, _createClass2.default)(UserDashboard, [{
    key: "getInitialState",
    value: function getInitialState() {
      var defaultMetricItem = (0, _utils.createDefaultMetricItem)();
      var queryParams = new _QueryParameters.default();

      var state = _objectSpread(_objectSpread({}, (0, _get2.default)((0, _getPrototypeOf2.default)(UserDashboard.prototype), "getInitialState", this).call(this)), {}, {
        totalUsers: defaultMetricItem,
        newRegistrations: defaultMetricItem,
        usersWithOnePost: defaultMetricItem,
        percentageUsersWithOnePost: 0,
        userRoles: [],
        ranks: [],
        selectedRoles: queryParams.has('roles') ? queryParams.get('roles').split(',') : [],
        mainRoles: [],
        customRoles: [],
        selectedRanks: queryParams.has('ranks') ? queryParams.get('ranks').split(',') : [],
        isUserRoleDropdownOpen: false,
        isRankDropdownOpen: false,
        isTotalUserKeyInsightLoading: false,
        isNewRegistrationKeyInsightLoading: false,
        isUserWithOnePostKeyInsightLoading: false,
        isPercentageUserWithOnePostKeyInsightLoading: false,
        selectedMainRoles: [],
        selectedCustomRoles: []
      });

      return state;
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        var _yield$Promise$all, _yield$Promise$all2, presetDateRanges, roles, rankList, defaultDateRange, _dateRangeForDisplay, dateFrom, dateTill, selectedDateRange, selectedPresetId, updatedState, selectedRoles, mainRoles, customRoles, totalUsersPromise, usersWithOnePostPromise;

        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                (0, _utils.trackDashboardUsage)('user-dashboard');
                _context6.next = 3;
                return (0, _get2.default)((0, _getPrototypeOf2.default)(UserDashboard.prototype), "componentDidMount", this).call(this);

              case 3:
                this.setState({
                  isLoading: true,
                  isTotalUserKeyInsightLoading: true,
                  isNewRegistrationKeyInsightLoading: true,
                  isUserWithOnePostKeyInsightLoading: true,
                  isPercentageUserWithOnePostKeyInsightLoading: true
                });
                _context6.prev = 4;
                _context6.next = 7;
                return Promise.all([this.fetchDateRangeFilter(), this.fetchUserRoles(), this.isRankModuleEnabled ? this.fetchRanks() : []]);

              case 7:
                _yield$Promise$all = _context6.sent;
                _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 3);
                presetDateRanges = _yield$Promise$all2[0];
                roles = _yield$Promise$all2[1];
                rankList = _yield$Promise$all2[2];
                defaultDateRange = (0, _utils.getDefaultDateRange)(presetDateRanges, this.state.selectedPresetDateRangeId);
                _dateRangeForDisplay = (0, _utils.dateRangeForDisplay)(this.state.storedState, defaultDateRange, this.state.selectedPresetDateRangeId), dateFrom = _dateRangeForDisplay.dateFrom, dateTill = _dateRangeForDisplay.dateTill, selectedDateRange = _dateRangeForDisplay.selectedDateRange, selectedPresetId = _dateRangeForDisplay.selectedPresetId, updatedState = _dateRangeForDisplay.updatedState;
                selectedRoles = this.state.selectedRoles;
                mainRoles = (0, _utils.getSelectedRolesForRequest)(roles, selectedRoles);
                customRoles = (0, _utils.getSelectedRolesForRequest)(roles, selectedRoles, false);
                this.setState({
                  userRoles: roles,
                  ranks: rankList,
                  presetDateRangeList: presetDateRanges,
                  selectedPresetDateRangeId: selectedPresetId,
                  selectedDate: selectedDateRange,
                  startDate: dateFrom,
                  endDate: dateTill,
                  storedState: updatedState,
                  isLoading: false,
                  mainRoles: mainRoles,
                  customRoles: customRoles
                });
                _context6.next = 24;
                break;

              case 20:
                _context6.prev = 20;
                _context6.t0 = _context6["catch"](4);

                _logger.logger.error(_context6.t0, {
                  component: 'UserDashboard',
                  action: 'componentDidMount'
                });

                this.setState({
                  isLoading: false
                });

              case 24:
                totalUsersPromise = this.fetchTotalUsers();
                this.fetchNewRegistrations();
                usersWithOnePostPromise = this.fetchUsersWithOnePost();
                _context6.next = 29;
                return usersWithOnePostPromise;

              case 29:
                _context6.next = 31;
                return totalUsersPromise;

              case 31:
                this.calculatePercentageUsersWithOnePost();

              case 32:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[4, 20]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "fetchTotalUsers",
    value: function () {
      var _fetchTotalUsers = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
        var res, _res$data, count, previousCount, percentageDifference;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.setState({
                  isTotalUserKeyInsightLoading: true
                });
                _context7.prev = 1;
                _context7.next = 4;
                return this.fetchData('/analyticsV2/fetchTotalUsers');

              case 4:
                res = _context7.sent;
                _res$data = res.data, count = _res$data.count, previousCount = _res$data.previousCount;
                percentageDifference = (0, _utils.previousPeriodDifference)(count, previousCount);
                this.setState({
                  totalUsers: {
                    count: count,
                    previousCount: previousCount,
                    percentageDifference: percentageDifference
                  },
                  isTotalUserKeyInsightLoading: false
                });
                _context7.next = 14;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7["catch"](1);

                _logger.logger.error(_context7.t0, {
                  component: 'UserDashboard',
                  action: 'fetchTotalUsers'
                });

                this.setState({
                  isTotalUserKeyInsightLoading: false
                });

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[1, 10]]);
      }));

      function fetchTotalUsers() {
        return _fetchTotalUsers.apply(this, arguments);
      }

      return fetchTotalUsers;
    }()
  }, {
    key: "fetchNewRegistrations",
    value: function () {
      var _fetchNewRegistrations = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
        var res, _res$data2, count, previousCount, percentageDifference;

        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.setState({
                  isNewRegistrationKeyInsightLoading: true
                });
                _context8.prev = 1;
                _context8.next = 4;
                return this.fetchData('/analyticsV2/fetchNewRegistrations');

              case 4:
                res = _context8.sent;
                _res$data2 = res.data, count = _res$data2.count, previousCount = _res$data2.previousCount;
                percentageDifference = (0, _utils.previousPeriodDifference)(count, previousCount);
                this.setState({
                  newRegistrations: {
                    count: count,
                    previousCount: previousCount,
                    percentageDifference: percentageDifference
                  },
                  isNewRegistrationKeyInsightLoading: false
                });
                _context8.next = 14;
                break;

              case 10:
                _context8.prev = 10;
                _context8.t0 = _context8["catch"](1);

                _logger.logger.error(_context8.t0, {
                  component: 'UserDashboard',
                  action: 'fetchNewRegistrations'
                });

                this.setState({
                  isNewRegistrationKeyInsightLoading: false
                });

              case 14:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[1, 10]]);
      }));

      function fetchNewRegistrations() {
        return _fetchNewRegistrations.apply(this, arguments);
      }

      return fetchNewRegistrations;
    }()
  }, {
    key: "fetchUsersWithOnePost",
    value: function () {
      var _fetchUsersWithOnePost = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
        var res, _res$data3, count, previousCount, percentageDifference;

        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.setState({
                  isUserWithOnePostKeyInsightLoading: true
                });
                _context9.prev = 1;
                _context9.next = 4;
                return this.fetchData('/analyticsV2/fetchUsersPostMetric');

              case 4:
                res = _context9.sent;
                _res$data3 = res.data, count = _res$data3.count, previousCount = _res$data3.previousCount;
                percentageDifference = (0, _utils.previousPeriodDifference)(count, previousCount);
                this.setState({
                  usersWithOnePost: {
                    count: count,
                    previousCount: previousCount,
                    percentageDifference: percentageDifference
                  },
                  isUserWithOnePostKeyInsightLoading: false
                });
                _context9.next = 14;
                break;

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9["catch"](1);

                _logger.logger.error(_context9.t0, {
                  component: 'UserDashboard',
                  action: 'fetchUsersWithOnePost'
                });

                this.setState({
                  isUserWithOnePostKeyInsightLoading: false
                });

              case 14:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[1, 10]]);
      }));

      function fetchUsersWithOnePost() {
        return _fetchUsersWithOnePost.apply(this, arguments);
      }

      return fetchUsersWithOnePost;
    }()
  }, {
    key: "calculatePercentageUsersWithOnePost",
    value: function () {
      var _calculatePercentageUsersWithOnePost = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
        var _this$state4, usersWithOnePost, totalUsers, percent;

        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.setState({
                  isPercentageUserWithOnePostKeyInsightLoading: true
                });
                _this$state4 = this.state, usersWithOnePost = _this$state4.usersWithOnePost, totalUsers = _this$state4.totalUsers;

                if (usersWithOnePost !== undefined && usersWithOnePost.count !== 0 && totalUsers.count !== undefined && totalUsers.count !== 0) {
                  percent = usersWithOnePost.count / totalUsers.count * 100;
                  this.setState({
                    percentageUsersWithOnePost: percent,
                    isPercentageUserWithOnePostKeyInsightLoading: false
                  });
                }

                this.setState({
                  isPercentageUserWithOnePostKeyInsightLoading: false
                });

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function calculatePercentageUsersWithOnePost() {
        return _calculatePercentageUsersWithOnePost.apply(this, arguments);
      }

      return calculatePercentageUsersWithOnePost;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state5 = this.state,
          totalUsers = _this$state5.totalUsers,
          newRegistrations = _this$state5.newRegistrations,
          usersWithOnePost = _this$state5.usersWithOnePost,
          percentageUsersWithOnePost = _this$state5.percentageUsersWithOnePost,
          presetDateRangeList = _this$state5.presetDateRangeList,
          userRoles = _this$state5.userRoles,
          selectedRoles = _this$state5.selectedRoles,
          isUserRoleDropdownOpen = _this$state5.isUserRoleDropdownOpen,
          ranks = _this$state5.ranks,
          selectedRanks = _this$state5.selectedRanks,
          isRankDropdownOpen = _this$state5.isRankDropdownOpen,
          isDateRangeOpen = _this$state5.isDateRangeOpen,
          selectedPresetDateRangeId = _this$state5.selectedPresetDateRangeId,
          startDate = _this$state5.startDate,
          endDate = _this$state5.endDate,
          isLoading = _this$state5.isLoading,
          selectedDate = _this$state5.selectedDate,
          isTotalUserKeyInsightLoading = _this$state5.isTotalUserKeyInsightLoading,
          isNewRegistrationKeyInsightLoading = _this$state5.isNewRegistrationKeyInsightLoading,
          isUserWithOnePostKeyInsightLoading = _this$state5.isUserWithOnePostKeyInsightLoading,
          isPercentageUserWithOnePostKeyInsightLoading = _this$state5.isPercentageUserWithOnePostKeyInsightLoading,
          shouldChartRedraw = _this$state5.shouldChartRedraw;
      return (0, _preact.h)("div", {
        className: "user-dashboard-overview dashboard-overview",
        "data-bounded-context": "Analytics",
        "data-entity": "user-dashboard"
      }, (0, _preact.h)(_header.default, {
        title: "User Dashboard",
        disableCancelButton: true,
        disableSaveButton: true
      }), (0, _preact.h)("div", {
        className: "filter-container",
        ref: function ref(node) {
          _this2.wrapperRef = node;
        }
      }, (0, _preact.h)(_DashboardDateRangeFilter.default, {
        isLoading: isLoading,
        startDate: startDate,
        endDate: endDate,
        isDropdownOpen: isDateRangeOpen,
        items: presetDateRangeList,
        selectedDate: selectedDate,
        selectedPresetId: selectedPresetDateRangeId,
        toggleDropdown: this.toggleDateRange,
        onChange: this.onDateRangeChanged,
        onReset: this.onResetDateRange,
        onCustomDateChange: this.onCustomDateRangeChanged,
        onPresetDateChange: this.onPresetDateRangeChanged,
        showMonths: 2,
        "data-element-name": "Date range filter",
        "data-track-type": "click"
      }), (0, _preact.h)(_DashboardSimpleFilter.default, {
        isLoading: isLoading,
        id: "userRole",
        name: "user role",
        customClassName: "user-role",
        title: "User role",
        isDropdownOpen: isUserRoleDropdownOpen,
        toggleDropdown: this.toggleUserRoleDropdown,
        resetDropdown: this.onResetUserRoles,
        onClear: this.onClearUserRoles,
        onChange: this.onUserRolesChanged,
        items: userRoles,
        selectedItems: selectedRoles,
        "data-element-name": "User role filter",
        "data-track-type": "click"
      }), this.isRankModuleEnabled && (0, _preact.h)(_DashboardSimpleFilter.default, {
        isLoading: isLoading,
        id: "ranks",
        name: "rank",
        customClassName: "rank",
        title: "Rank",
        isDropdownOpen: isRankDropdownOpen,
        toggleDropdown: this.toggleRankDropdown,
        resetDropdown: this.onResetRanks,
        onClear: this.onClearRanks,
        onChange: this.onRanksChanged,
        items: ranks,
        selectedItems: selectedRanks,
        "data-element-name": "Rank filter",
        "data-track-type": "click"
      })), (0, _preact.h)("div", {
        className: "metric-container"
      }, (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Total users",
        isLoading: isTotalUserKeyInsightLoading,
        total: totalUsers.count,
        titleTooltip: "The total number of registered users on the community up to the end of the selected time period.",
        percent: totalUsers.percentageDifference,
        showComparisionUnavailable: totalUsers.previousCount === 0,
        comparisionTooltip: "The percentage difference between the total number of registered users in the current/previous time period."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "New registrations",
        isLoading: isNewRegistrationKeyInsightLoading,
        total: newRegistrations.count,
        titleTooltip: "The number of new registrations in the selected time period.",
        percent: newRegistrations.percentageDifference,
        showComparisionUnavailable: newRegistrations.previousCount === 0,
        comparisionTooltip: "The percentage difference between the number of new registrations in the current/previous time period."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Users with at least 1 post",
        isLoading: isUserWithOnePostKeyInsightLoading,
        total: usersWithOnePost.count,
        titleTooltip: "The number of users who created at least one topic or reply in the selected time period.",
        percent: usersWithOnePost.percentageDifference,
        showComparisionUnavailable: usersWithOnePost.previousCount === 0,
        comparisionTooltip: "The percentage difference between the number of users who created at least one topic or reply in the current/previous time period."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "% Users with at least 1 post",
        isLoading: isPercentageUserWithOnePostKeyInsightLoading,
        total: percentageUsersWithOnePost,
        isPercentage: true,
        hideComparisionWithPreviousPeriod: true,
        titleTooltip: "The % of users who created at least one topic or reply in the selected time period, compared to the total number of users."
      })), (0, _preact.h)("div", {
        className: "graph-wrapper"
      }, (0, _preact.h)("div", {
        className: "graph-container",
        ref: function ref(element) {
          _this2.barChart = element;
        }
      }, (0, _preact.h)(_NewRegistrationsGraph.default, {
        startDate: startDate,
        endDate: endDate,
        selectedRoles: selectedRoles,
        selectedRanks: selectedRanks,
        fetchData: this.fetchData,
        shouldChartRedraw: shouldChartRedraw
      }))), (0, _preact.h)(_TopUsersTable.default, {
        startDate: startDate,
        endDate: endDate,
        selectedRoles: selectedRoles,
        selectedRanks: selectedRanks,
        fetchData: this.fetchData
      }), (0, _preact.h)(_DashboardTimezoneDisclaimer.DashboardTimezoneDisclaimer, null));
    }
  }]);
  return UserDashboard;
}(_interfaces.Dashboard);

var _default = UserDashboard;
exports.default = _default;